module.exports = __webpack_public_path__ + "img/myself02.62f6bf5b.png";